module.exports = __webpack_public_path__ + "static/media/undraw_new_message.ec399371.svg";